
























import {Vue, Component} from 'vue-property-decorator'
import buildInfo from '@/assets/build-info.json'
import {appStore} from '@/store'

@Component({
  name: 'AppProjectSplashScreen',
})
export default class AppProjectSplashScreen extends Vue {
  get appName() {
    return Vue.$appName
  }
  get appVersionInfo(): string {
    return `v${Vue.$appVersion}, build ${buildInfo.buildId} of ${buildInfo.buildDate}`
  }
  get loadingProject(): boolean {
    return appStore.appLoadingProject
  }
}
